<project-details-default-header [project]="project"></project-details-default-header>
<div class="messages-section box_default box_white">
  <header>
      <h3>MESSAGES</h3>
  </header>

  <!-- PROJECT messages with access check-->
  <article  class="messages-section-main">

    <project-details-messages-add
      [project]="project"
    ></project-details-messages-add>

    <project-details-messages-list
      [project]="project"
      [user]="user"
    ></project-details-messages-list>
  </article>


</div >
